import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {ff, form} from "@mc/mc-legacy";
import {Component} from "react";
import * as React from "react";
const {Form, FormActions, FormBody} = form;
import CustomCheckboxField from "../components/CustomCheckboxField";
import {withTranslation, WithTranslation} from "react-i18next";

/**
 * Formulář pro tvorbu/úpravu adresy.
 */
class AdresaForm extends Component<WithTranslation> {

    static formName = 'AdresaForm';

    static propTypes = {
        showNeaktivni: PropTypes.bool, // zda zobrazovat zatržítko "neaktivní", implicitně true
        showFakturacni: PropTypes.bool, // zda zobrazovat zatržítko "fakturační", implicitně true
    };

    static defaultProps = {
        showNeaktivni: true,
        showFakturacni: true,
    };

    render() {
        const {onClose, submitting, handleSubmit, showNeaktivni, showFakturacni, t} = this.props;
        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <ff.String label={t('street')} name="ulice" disabled={submitting}/>
                <ff.String label={t('zip')} name="psc" disabled={submitting}/>
                <ff.String label={t('city')} name="obec" disabled={submitting}/>
                <ff.String label={t('country')} name="stat" disabled={submitting}/>
                <CustomCheckboxField label={t('default')} name="vychozi" disabled={submitting}/>
                {showFakturacni && <CustomCheckboxField label={t('billing')} name="fakturacni" disabled={submitting}/>}
                {showNeaktivni && <CustomCheckboxField label={t('inactive')} name="neaktivni" disabled={submitting}/>}
            </FormBody>
            <FormActions onClose={onClose} storeButton={t('save')} cancelButton={t('buttons.cancel')} disabled={submitting}/>
        </Form>
    }
}

export default withTranslation()(connect()(reduxForm({
    form: AdresaForm.formName,
})(AdresaForm)));
